import { storage } from './storage';

const CONSENT_KEY = 'analytics-consent';

export function getAnalyticsConsent() {
  return storage.get(CONSENT_KEY);
}

export function setAnalyticsConsent(value) {
  storage.set(CONSENT_KEY, value);
  if (value === 'accepted') {
    if (window.__loadGA) window.__loadGA();
    if (window.__loadMetaPixel) window.__loadMetaPixel(); // NER-3217
  }
}

export function trackEvent(name, params) {
  if (window.gtag) window.gtag('event', name, params);
}

// NER-3217: Meta Pixel — no-op sin consentimiento (fbq no existe si no cargó)
export function trackPixel(eventName, params) {
  if (window.fbq) window.fbq('track', eventName, params);
}
